import { makeAutoObservable, observable } from "mobx"
import { nanoid } from "nanoid"
import Content from "./content"

class Project {

  id: string
  name: string = ""
  slug: string = ""
  contents = observable.map<string, Content>([])

  constructor(id?: string) {
    this.id = id || nanoid(4)
    makeAutoObservable(this)
  }

  addContent(content: Content) {
    this.contents.set(content.id, content)
    return content
  }

  deleteContent(contentId: string) {
    this.contents.delete(contentId)
  }

  save(contentIds: Set<string>) {
    return {
      id: this.id,
      name: this.name,
      slug: this.slug,
      contents: Array.from(this.contents.values())
        .filter(content => contentIds.has(content.id))
        .map(content => content.save())
    }
  }

  saveInfo() {
    return {
      id: this.id,
      name: this.name,
      slug: this.slug,
      contentIds: Array.from(this.contents.keys())
    }
  }

}

export default Project